document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a.trigger_search').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault(); // prevent default anchor behavior
      const searchBtn = document.querySelector('search-button button.search-modal__button');
      if (searchBtn) searchBtn.click();
    });
  });
  document.querySelectorAll('a.f_cart').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault(); // prevent default anchor behavior
      const cartBtn = document.querySelector('.cart-drawer button.button.header-actions__action');
      if (cartBtn) cartBtn.click();
    });
  });
  document.querySelectorAll('a.f_menu').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault(); // prevent default anchor behavior
      const menuBtn = document.querySelector('#Details-menu-drawer-container summary.header__icon.header__icon--menu');
      if (menuBtn) menuBtn.click();
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {

 

  const wishlistButtons = document.querySelectorAll(".wishlist-btn, .wishlist-collection-btn");

  const wishlist = JSON.parse(localStorage.getItem("wishlistshima")) || [];

  wishlistButtons.forEach((btn) => {
    const handle = btn.dataset.productHandle;

    // Check if already in wishlist
    if (wishlist.includes(handle)) {
      btn.classList.add("in-wishlist");
      btn.disabled = true; // Only disable if already wishlisted
    }

    // Add click handler only if not already wishlisted
    if (!wishlist.includes(handle)) {
      btn.addEventListener("click", function (event) {
        // Prevent anchor behavior if button is inside an <a>
        event.preventDefault();
        event.stopPropagation();

        wishlist.push(handle);
        localStorage.setItem("wishlistshima", JSON.stringify(wishlist));
        btn.classList.add("in-wishlist");
        btn.disabled = true; // Optional: prevent multiple clicks
        updateWishlistCount();
      });
    }
  });

  function updateWishlistCount() {
    const wishlist = JSON.parse(localStorage.getItem("wishlistshima")) || [];
    const countElem = document.getElementById("wishlist-count");
    if (countElem) {
      countElem.textContent = wishlist.length;
    }
  }

  updateWishlistCount();
});




/*$(document).on("click", ".resource-list__item a", function () {
  var getRedirectUrl = $(this).attr('href');
  window.location=getRedirectUrl;
  //console.log("PCARD"+getRedirectUrl);
});*/ 

$(document).on("click", ".add-to-cart-text--added", function () {
  console.log("ATC 1");
  setTimeout(function () {
    const wishlist1 = JSON.parse(localStorage.getItem("wishlistshima")) || [];
    const countElem1 = document.getElementById("wishlist-count");
    if (countElem1) {
      countElem1.textContent = wishlist1.length;
    }
    //console.log("ATC 2"+wishlist1.length);
  }, 2000); // 1000ms = 1 second
});


function upsellSlider()
{
  //console.log("upsellSlider");
  const slider = document.querySelector('.upsell-slider');
  const slides = document.querySelectorAll('.upsell-slide');
  const dotsContainer = document.querySelector('.upsell-dots');

  let currentSlide = 0;

  // Create dots
  slides.forEach((_, index) => {
    const dot = document.createElement('button');
    if (index === 0) dot.classList.add('active');
    dot.addEventListener('click', () => goToSlide(index));
    dotsContainer.appendChild(dot);
  });

  const updateDots = () => {
    const dots = dotsContainer.querySelectorAll('button');
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === currentSlide);
    });
  };

  const goToSlide = (index) => {
    currentSlide = index;
    slider.style.transform = `translateX(-${100 * index}%)`;
    updateDots();
  };
}  

$(document).on('click', '.custom_cart_items button.button', function(e) {
    setTimeout(function() {
      upsellSlider();
    }, 1500);
});
$(document).on('click', '.add-to-cart-button', function(e) {
    setTimeout(function() {
      const dotButtons = document.querySelectorAll('.upsell-dots button');

      if (dotButtons.length > 0) {
        console.log("Dots Exist");
        
      } else {
        console.log("Dots Not Exist");
        upsellSlider();
      }

      
    }, 2500);
});
document.addEventListener('DOMContentLoaded', function () {
  
  upsellSlider();
  // Add to cart handler
  document.addEventListener('click', function (e) {
  if (e.target.classList.contains('upsell-add-btn')) {
    const variantId = e.target.getAttribute('data-id');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(cart => {
      const cartCountEl = document.querySelector('.cart-count');
      if (cartCountEl) {
        cartCountEl.textContent = cart.item_count;
      }

      // Optional: Re-render cart drawer (if using a cart drawer)
      fetch('/?view=CartDrawer')
        .then(res => res.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
      
          const drawerContent = tempDiv.querySelector('#CartDrawer');
          if (drawerContent) {
            const drawer = document.querySelector('#CartDrawer');
            if (drawer) drawer.innerHTML = drawerContent.innerHTML;
            setTimeout(function() {
              upsellSlider();
            }, 1500);
          } else {
            console.log('No #CartDrawer found in response HTML.');
          }
        });
    })
      .catch(err => console.error('Error adding upsell item:', err));
  }
});

});  

/*function updateAccordion() {
  if ($(window).width() > 750) {
    // Close all first
    $('.temp_product .product-details.sticky-content--desktop accordion-custom .details').removeAttr('open');
    // Open only the first one
    $('.temp_product .product-details.sticky-content--desktop accordion-custom:eq(0) .details').attr('open', '');
  } else {
    // Close all on smaller screens
    $('.temp_product .product-details.sticky-content--desktop accordion-custom .details').removeAttr('open');
  }
}

// Run on initial load
updateAccordion();

// Run on window resize
$(window).on('resize', updateAccordion);*/


  window.addEventListener('scroll', function () {
    if (window.scrollY === 0) {
      document.body.classList.add('at-top');
      document.body.classList.remove('scrolled');
    } else {
      document.body.classList.add('scrolled');
      document.body.classList.remove('at-top');
    }
  });

  // Optional: run on load to set initial state
  window.addEventListener('load', function () {
    if (window.scrollY === 0) {
      document.body.classList.add('at-top');
    } else {
      document.body.classList.add('scrolled');
    }
  });